module.exports = __webpack_public_path__ + "static/media/football_counter.661355d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/football_counter.jpg
// module id = 54
// module chunks = 0